import { useContext } from 'react';
import context from './authContext';

export default function useAuth() {
  const value = useContext(context);
  if (value === undefined) {
    throw new Error(
      `${useAuth.name} must be used within a ${context.displayName || 'context'} Provider`,
    );
  }

  return value;
}
